/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfPageRegistryDto } from '../../models/paginated-dto-of-page-registry-dto';

export interface FindAllPages$Params {
}

export function findAllPages(http: HttpClient, rootUrl: string, params?: FindAllPages$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfPageRegistryDto>> {
  const rb = new RequestBuilder(rootUrl, findAllPages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfPageRegistryDto>;
    })
  );
}

findAllPages.PATH = '/api/v1/pages';
